<template>
  <div id="app">
    <div>
      <el-row>
        <el-col :span="4">
          <el-select
            v-model="filters.stockType"
            @change="getStock"
            placeholder="请选择"
          >
            <el-option label="Erp库存" :value="0"></el-option>
            <el-option label="工控机库存" :value="100"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-show="filters.stockType == 100"
            v-model="filters.stationLineId"
            placeholder="请选择"
            @change="getStock"
          >
            <el-option
              v-for="item in stationLine"
              :key="item.Id + '_addstation'"
              :label="item.Name"
              v-model="item.Id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click.native="getStock()">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div v-for="item in list" :key="item.id + '_bc1'">
      <div style="width: 100%; text-align: center; font-size: 30px">
        {{ item.name }}
      </div>
      <div class="jar-area" v-if="item.data.length > 0">
        <div class="jar" v-for="jar in item.data" :key="jar.WarehouseName + '_' + jar.MatName">
          <div class="jar-image">
            <div class="l1"></div>
            <div class="l2"></div>
            <div
              class="jar-fill"
              :style="{
                height:
                  (jar.MaxQuantity > 0
                    ? Number(jar.Quantity) / jar.MaxQuantity
                    : 0) *
                    100 +
                  '%',
              }"
            ></div>
            <div class="r1"></div>
            <div class="r2"></div>
          </div>
          <div class="jar-top">
            <div>{{ jar.WarehouseName }}</div>
            <div class="jar-kou">{{ jar.MatName }}</div>
          </div>
          <div class="jar-middle">
            <div>{{ (jar.Quantity / 1000).toFixed(2) }}吨</div>
            <div class="jar-p">
              {{
                (
                  (jar.MaxQuantity > 0
                    ? Number(jar.Quantity) / jar.MaxQuantity
                    : 0) * 100
                ).toFixed(2)
              }}%
            </div>
          </div>
          <div class="jar-bottom">
            <div>{{ Number(jar.MaxQuantity) / 1000 }}吨</div>
          </div>
        </div>
      </div>
      <div style="width: 100%; text-align: center" v-else>无</div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/command";
import { getSysStationLineListPage } from "../../api/recipe";
export default {
  name: "App",
  data() {
    return {
      list: [],
      orgId: "",
      stationLine: [],
      stationAndStock: [],
      filters: {
        stockType: 0,
      },
    };
  },
  computed: {},
  methods: {
    getSysStationLineList() {
      let para = {
        key: this.orgId,
      };
      getSysStationLineListPage(para)
        .then((res) => {
          this.stationLine = res.data.response.data;
          if (res.data.response.data.length > 0) {
            this.filters.stationLineId = this.stationLine[0].Id;
          } else {
            this.filters.stationLineId = null;
          }
        })
        .finally(() => {});
    },
    getStock() {
      let para = this.filters;
      let _this = this;
      api.GetStockReport(para).then((res) => {
        if (res && res.data && res.data.success) {
          let result = [];
          let stationLine = JSON.parse(JSON.stringify(this.stationLine));
          stationLine.push({
            id: null,
          });
          stationLine.forEach((line) => {
            result.push({
              id: line.Id ? line.Id : "-1",
              name: line.Id ? line.Name : "未定义生产线",
              data: res.data.response.filter((x) => x.StationLineID == line.Id),
            });
          });
          this.list = result;
        } else {
          this.list = [];
        }
      });
    },
  },
  mounted() {
    if (this.orgId == "") {
      if (localStorage.currentOrg) {
        this.orgId = JSON.parse(localStorage.currentOrg).Id;
      } else if (localStorage.sysOrgs) {
        this.orgId = JSON.parse(localStorage.sysOrgs)[0].Id;
      }
    }
    this.getSysStationLineList();
    this.getStock();
  },
};
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  overflow-y: auto;
  background-size: cover;
}
.jar-area {
  font-family: "Microsoft YaHei";
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 10px;

  .jar {
    user-select: none;
    width: 100px;
    text-align: center;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin: auto 20px;

    .jar-image {
      position: absolute;
      height: 140px;
      width: 100px;
      top: 40px;
      z-index: -1;
      overflow: hidden;
      background: url(../../assets/guanzi.png) no-repeat;
      background-size: cover;
      &:before {
        content: "";
        display: block;
        height: 132px;
        width: 92px;
        position: absolute;
        //border: 4px solid #000;
        top: 0;
        left: 0;
        z-index: 99;
      }

      .l1,
      .l2,
      .r1,
      .r2 {
        content: "";
        display: block;
        border: 30px solid #fff;
        border-color: transparent transparent #fff transparent;
        position: absolute;
        bottom: 0;
        left: -30px;
        z-index: 999;

        &.l2 {
          //border: 35px solid #000;
          border-color: transparent transparent #000 transparent;
          z-index: 998;
          left: -35px;
        }

        &.r1 {
          right: -30px;
          left: initial;
        }

        &.r2 {
          left: initial;
          right: -35px;
          //border: 35px solid #000;
          border-color: transparent transparent #000 transparent;
          z-index: 998;
        }
      }

      .jar-fill {
        height: 100%;
        position: absolute;
        background: #2383e561;
        width: 96%;
        bottom: 0;
      }
    }
  }
}
</style>
